<template>
  <b-tab :title="$t('PROFILE_INVOICES_TAB_TITLE')">
    <div class="mt-3">
      <loading v-if="isLoading" />
      <template v-if="!isLoading">
        <p v-if="invoices.length === 0" class="text-muted">
          {{ $t('NODATAFOUND') }}
        </p>
        <div v-else style="overflow-y: auto; max-height: 60vh;">
          <table class="table table-sm table-bordered mb-0">
            <thead>
              <tr>
                <th>{{ $t('PROFILE_INVOICE_ISSUE_DATE') }}</th>
                <th>{{ $t('PROFILE_INVOICE_AMOUNT') }}</th>
                <th>{{ $t('PROFILE_INVOICE_PAYMENT_DATE') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in invoices"
                :key="item.userInvoiceId"
                :class="rowClass(item)">
                <td>{{ formatDate(item.issueDate) }}</td>
                <td>{{ formatAmount(item.amount) }}</td>
                <td>{{ item.paymentDate ? formatDate(item.paymentDate) : $t('PROFILE_INVOICE_UNPAID') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination v-if="totalCount > pagination.limit" v-model="pagination" :total-count="totalCount" class="mt-2" />
      </template>
    </div>
  </b-tab>
</template>

<script>
import moment from 'moment';
import Api from '@/api/user_invoices/UserInvoices';

export default
{
    name: 'profile-invoices-tab',
    data()
    {
        return {
            isLoading: false,
            invoices: [],
            totalCount: 0,
            pagination:
            {
                currentPage: 1,
                limit: 25,
            },
        };
    },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                this.getData();
            },
        },
    },
    created()
    {
        this.getData();
    },
    methods:
    {
        async getData()
        {
            const me = this;
            me.isLoading = true;
            try
            {
                const start = (me.pagination.currentPage - 1) * me.pagination.limit;
                const data = await Api.selectUserInvoices(
                    {
                        start,
                        limit: me.pagination.limit,
                    },
                );
                me.invoices = data.root;
                me.totalCount = data.totalCount;
            }
            catch (e)
            {
                me.$notify.notice(e);
            }
            finally
            {
                me.isLoading = false;
            }
        },
        rowClass(item)
        {
            if (item.paymentDate != null)
            {
                return 'table-success';
            }
            const days = moment().diff(moment(item.issueDate), 'days');
            return days > 7 ? 'table-danger' : 'table-success';
        },
        formatDate(val)
        {
            return moment(val).format('DD.MM.YYYY');
        },
        formatAmount(val)
        {
            return parseFloat(val).toFixed(2);
        },
    },
};
</script>
